<template>
  <form :autocomplete="autocomplete ? 'ON' : 'OFF'" @submit.prevent="onSubmit">
    <slot />
    <input v-show="false" type="submit" value="Submit" class="hidden"/>
  </form>
</template>

<script setup lang="ts">
import { computed, watch, ref, nextTick, provide } from 'vue'
import useValidate from 'vue-tiny-validate'

const props = defineProps<{
  formData?: any
  rules?: any
  autocomplete?: boolean
  autoValidate?: boolean
  disabled?: boolean
  onSubmit?: () => void
}>()

const { result } = useValidate(props.formData, props.rules || ref({}))
const silent = ref(false)

provide('validation', computed(() => result.value))
provide('form-disabled', computed(() => props.disabled))

const validate = (prop?: string) => {
  if (prop && result.value[prop]) {
    result.value[prop].$test()
    return !result.value[prop].$invalid
  }

  result.value.$test()

  return !result.value.$invalid
}

watch(
  () => props.formData,
  () => {
    if (props.autoValidate) validate()
  },
  { deep: true }
)

defineExpose({
  validate,
  resetValidate: () => {
    silent.value = true
    result.value.$reset()
    nextTick(() => silent.value = false)
  },
  invalid: computed(() => result.value.$invalid),
  getErrors: (prop?: string) => (prop ? result.value[prop].$messages : result.value.$messages),
  getCurrentError: (prop?: string) => (prop ? result.value[prop]?.$messages[0] : result.value?.$messages[0]) || '',
  hasError: (prop?: string) => (prop ? result.value[prop].$invalid : result.value.$invalid),
  result
})
</script>
